import React, {ReactNode, useEffect} from 'react';
import Page from '@episerver/spa-core/Page';
import ClientLocationPageData from '../../../Models/Content/ClientLocationPageData';
import ClientLocationMainComponent from './ClientLocationMainComponent';

export default class ClientLocationPage extends Page<ClientLocationPageData> {
  public render(): ReactNode {
    return <ClientLocationMainComponent context={this.getContext()} contentData={this.props.data} />;
  }
}
